import React from 'react';

const DeleteUser = ({deleteUser}) => {
    return (
        <a onClick={deleteUser}> Delete user</a>
    )
}

export default DeleteUser;




// WEBPACK FOOTER //
// ./src/components/Admin/Users/DeleteUser.js